import { Map } from "immutable";
import { ModuleEvents } from "./Actions";
import _, { get, isArray, isEmpty, orderBy } from "lodash";

const initialState = Map({
  courseCategories: [],
  selectedService: null,
});

export const Reducer = (state = initialState, action) => {
  const { payload, type, error } = action;

  switch (action.type) {
    case ModuleEvents.FETCH_COURSE_CATEGORIES: {
      if (isArray(payload) && !payload.error) {
        return state.set("courseCategories", payload);
      }
      return state;
    }
    case ModuleEvents.SEARCH_CATEGORIES: {
      if (payload && !payload.error) {
        return state.set("category", { ...payload });
      }
      return state;
    }
    case ModuleEvents.CREATE_COURSE_CATEGORY: {
      if (payload && !payload.error) {
        return state.set("category", { ...payload });
      }
      return state;
    }
    case ModuleEvents.UPDATE_COURSE_CATEGORY: {
      const { result } = payload;
      if (result && !result.error) {
        return state.set("category", { ...result });
      }
      return state;
    }
    default:
      return state;
  }
};

export default Reducer;
